export const BRAND_NAME = 'ParkPing';

export const BRAND_CORE_MESSAGE =
  'Privacy-first smart parking contact system';

export const BRAND_CORE_EXPLANATION =
  'When a vehicle is blocked, the caller dials the toll-free number, enters the 4-digit code, and gets connected to the owner without seeing any personal phone number.';

export const BRAND_TRUST_POINTS = [
  'Vehicle owner privacy',
  'Women safety',
  'Damage prevention',
  'No app required',
] as const;

export const PAGE_META_DESCRIPTION =
  'ParkPing helps people contact parked vehicle owners without exposing personal phone numbers. Trusted, simple, and privacy-first communication for homes, offices, and public parking.';
